import { baseMenu, chatMenu, ordersMenu, blockedOrdersMenuItem, directoryMenu, controlMenu, cloneMenu, settingsMenu, reportsMenu, helpMenu } from './menuParts';

export const menuConfig = {
  Programmer: [
    { heading: "Programmer" },
    ...baseMenu,
    chatMenu,
    { ...ordersMenu, children: [...ordersMenu.children, blockedOrdersMenuItem] },
    directoryMenu,
    controlMenu,
    { icon: "mdi-account-cash", text: "partnerControl", link: "PartnerControl" },
    reportsMenu,
    settingsMenu,
    helpMenu
  ],
  Pharmacy: [
    ...baseMenu,
    chatMenu,
    cloneMenu(ordersMenu, ['adminarchive']),
    cloneMenu(directoryMenu, ["cities", "users"]),
    cloneMenu(reportsMenu, ["priceMonitoring","averagePriceReport"]),
    settingsMenu,
    helpMenu
  ],
  Pharmacy_administrator: [
    ...baseMenu,
    chatMenu,
    ordersMenu,
    directoryMenu,
    cloneMenu(reportsMenu),
    settingsMenu,
    helpMenu
  ],
  Pharmacy_center: [
        ...baseMenu,
    chatMenu,
    ordersMenu,
    cloneMenu(directoryMenu, ["users"]),
    cloneMenu(reportsMenu, ["priceMonitoring", "averagePriceReport", "priceActuality"]),
    settingsMenu,
    helpMenu
  ],
  Filial: [
    { heading: "Filial" },
    { icon: "mdi-home", text: "main", link: "/" },
    chatMenu,
    cloneMenu(directoryMenu, ["cities", "suppliers", "goods", "annotation", "users"]), // только цены
    cloneMenu(reportsMenu, ["priceMonitoring", "topProductsSold"]),
    helpMenu
  ],
  Filial_administrator: [
    { heading: "Filial_administrator" },
    { icon: "mdi-home", text: "main", link: "/" },
    chatMenu,
    cloneMenu(directoryMenu, ["cities", "suppliers", "goods", "annotation", "users"]), // только цены
    cloneMenu(reportsMenu, ["priceMonitoring", "topProductsSold"]),
    helpMenu
  ],
  Producer: [],
  Producer_administrator: [],
  Manager: [
    { heading: "MANAGER" },
    ...baseMenu,
    chatMenu,
    { ...ordersMenu, children: [...ordersMenu.children, blockedOrdersMenuItem] },
    directoryMenu,
    cloneMenu(controlMenu, ["access", "Hangfire"]),
    { icon: "mdi-account-cash", text: "partnerControl", link: "PartnerControl" },
    reportsMenu,
    settingsMenu,
    helpMenu
  ],
  Regional_partner: [
    { icon: "mdi-handshake", text: "partnerCabinet", link: "PartnerCabinet" },
    ...baseMenu,
    chatMenu,
    cloneMenu(ordersMenu, ['adminarchive']),
    cloneMenu(directoryMenu, ["cities", "users"]),
    settingsMenu,
    helpMenu
  ],
  Accountant: [
    {
      chatMenu,
      icon: "mdi-chevron-up",
      "icon-alt": "mdi-chevron-down",
      text: "Управление",
      model: false,
      children: [
        { icon: "mdi-newspaper-variant-outline", text: "Контроллер", link: "UserAccessControl" }
      ]
    },
    helpMenu
  ]
};
